import { HCPOnboardingState } from '../types/hcpOnboarding.types'
import { createSlice } from '@reduxjs/toolkit'

const initialState: HCPOnboardingState = {
  npiData: null,
  providerInfo: null,
  states: null,
  searchFacilityData: null,
  checkHCPUserEmail: null,
  providerAssociatedFacilities: null,
  isDuplicateFacility: null,
  showOnboardingLoader: null,
  showLoginPageLoader: null,
  clientData: null,
  programAndClientInfoForHCP: null,
  hcpConfiguration: null,
  workingHoursByDate: null,
  portalDetails: null,
  micrositePersonaDetails: null,
  microSiteselectedPersonaId: null,
  enrollmentId: null,
  successVerbiage: null,
  errorVerbiage: null,
  loaderVerbiage: null,
  successVerbiageHTML: null,
  errorVerbiageHTML: null,
  loaderVerbiageHTML: null,
  fillPdfUrl: null,
  fillPdfEId: null,
  microSiteselectedPersona: null,
  enrollmentFlowId: null,
  enrollmentLayoutSaveData: null,
  copaySaveData: null,
  selectedProductName: null,
  consenterName: null,
  micrositeToken: null,
  micrositeTokenCopy: null,
  consenterPersona: null,
  selectedProductId: null,
  loggedInUserAuthInfo: null,
  hcpVerifyEmailId: null,
  practiceRegistrationSessionId: null,
  hcpPracticeId: null,
  hcpUserId: null,
  hcpUserTypeId: null,
  patientName: null,
  hcpUserEmail: null,
  globalFont: null,
  primaryFont: null,
  docusignTokenDecodeData: null,
  counter: null,
  docusignParamToken: null,
  docusignLoginValidationToken: null,
  defaultFacilitySearchData: null,
  defaultPatientInfoTrackingPortal: null,
  isEnabledApplicationInstructions: null,
  isTrackingPortal: false,
  siblingLayoutSaveData: null,
  quickDenialMsg: '',
  consentEmail: null,
  midocs: [],
  miconsents: [],
  applicationStatusCaseId: null,
  quickDenialBackendMsg: [],
  secureToken: null,
  buttonConfigurationPageSpecificFieldMap: null,
  selectedServices: null,
  activeTemplate: null,
  activeLayoutId: null,
  micrositePrefilledData: null,
  extendedMicrositePrefilledData: null,
  prefilledAttachmentData: null,
  selectedServicesData: null,
  isCopayQuestionsEnabled: false,
  isBackTrackingProductServicePage: false,
  isBackMicrositeProductServicePage: false,
  copayVerbiage: null,
}

const hcpOnboardingSlice = createSlice({
  name: 'hcpOnboarding',
  initialState: initialState,
  reducers: {
    updateButtonConfigurationPageSpecificFieldMap: (
      state: HCPOnboardingState,
      action
    ) => {
      state.buttonConfigurationPageSpecificFieldMap = action.payload
    },
    updateHcpVerifyEmailId: (state: HCPOnboardingState, action) => {
      state.hcpVerifyEmailId = action.payload
    },
    updatePrefilledAttachmentData: (state: HCPOnboardingState, action) => {
      state.prefilledAttachmentData = action.payload
    },
    updateMicrositePrefillData: (state: HCPOnboardingState, action) => {
      state.micrositePrefilledData = action.payload
    },
    updateExtendedMicrositePrefillData: (state: HCPOnboardingState, action) => {
      state.extendedMicrositePrefilledData = action.payload
    },
    updateMIDocs: (state: HCPOnboardingState, action) => {
      state.midocs = action.payload
    },
    updateApplicationStatusCaseId: (state: HCPOnboardingState, action) => {
      state.applicationStatusCaseId = action.payload
    },
    updateMIConsent: (state: HCPOnboardingState, action) => {
      state.miconsents = action.payload
    },
    updateConsentEmail: (state: HCPOnboardingState, action) => {
      state.consentEmail = action.payload
    },
    updateQuickDenialMsg: (state: HCPOnboardingState, action) => {
      state.quickDenialMsg = action.payload
    },
    updateQuickDenialBackendMsg: (state: HCPOnboardingState, action) => {
      state.quickDenialBackendMsg = action.payload
    },
    updateIsTrackingPortal: (state: HCPOnboardingState, action) => {
      state.isTrackingPortal = action.payload
    },
    updateHcpDefaultFacilitySearchData: (state: HCPOnboardingState, action) => {
      state.defaultFacilitySearchData = action.payload
    },
    updateHCPDefaultPatientInfoTrackingPortal: (
      state: HCPOnboardingState,
      action
    ) => {
      state.defaultPatientInfoTrackingPortal = action.payload
    },
    updateDocusignValidationToken: (state: HCPOnboardingState, action) => {
      state.docusignLoginValidationToken = action.payload
    },
    updateHCPDocusignToken: (state: HCPOnboardingState, action) => {
      state.docusignParamToken = action.payload
    },
    updateDocusignLoginCounter: (state: HCPOnboardingState, action) => {
      state.counter = action.payload
    },
    updateHcpDecodeToken: (state: HCPOnboardingState, action) => {
      state.docusignTokenDecodeData = action.payload
    },
    updateGlobalFont: (state: HCPOnboardingState, action) => {
      state.globalFont = action.payload
    },
    updatePrimaryFont: (state: HCPOnboardingState, action) => {
      state.primaryFont = action.payload
    },
    updateHcpUserEmail: (state: HCPOnboardingState, action) => {
      state.hcpUserEmail = action.payload
    },
    updateHcpPracticeRegistrationSessionId: (
      state: HCPOnboardingState,
      action
    ) => {
      state.practiceRegistrationSessionId = action.payload
    },
    updateMicrositeToken: (state: HCPOnboardingState, action) => {
      state.micrositeToken = action.payload
    },
    updateMicrositeTokenCopy: (state: HCPOnboardingState, action) => {
      state.micrositeTokenCopy = action.payload
    },
    updateHCPPracticeId: (state: HCPOnboardingState, action) => {
      state.hcpPracticeId = action.payload
    },
    updateHCPPatientName: (state: HCPOnboardingState, action) => {
      state.patientName = action.payload
    },
    updateHCPUserId: (state: HCPOnboardingState, action) => {
      state.hcpUserId = action.payload
    },
    updateHCPUserTypeId: (state: HCPOnboardingState, action) => {
      state.hcpUserTypeId = action.payload
    },
    updateLoggedInUserAuthInfo: (state: HCPOnboardingState, action) => {
      state.loggedInUserAuthInfo = action.payload
    },
    updateNPIData: (state: HCPOnboardingState, action) => {
      state.npiData = action.payload
    },
    updateConsenterName: (state: HCPOnboardingState, action) => {
      state.consenterName = action.payload
    },
    updateConsenterPersona: (state: HCPOnboardingState, action) => {
      state.consenterPersona = action.payload
    },
    updateSelectedProductName: (state: HCPOnboardingState, action) => {
      state.selectedProductName = action.payload
    },
    updateSelectedProductId: (state: HCPOnboardingState, action) => {
      state.selectedProductId = action.payload
    },
    updateBackTrackingProductServicePage: (
      state: HCPOnboardingState,
      action
    ) => {
      state.isBackTrackingProductServicePage = action.payload
    },
    updateBackMicrositeProductServicePage: (
      state: HCPOnboardingState,
      action
    ) => {
      state.isBackMicrositeProductServicePage = action.payload
    },
    updateFillPdfUrl: (state: HCPOnboardingState, action) => {
      state.fillPdfUrl = action.payload
    },
    updateFillPdfEId: (state: HCPOnboardingState, action) => {
      state.fillPdfEId = action.payload
    },
    updateSuccessVerbiage: (state: HCPOnboardingState, action) => {
      state.successVerbiage = action.payload
    },
    updateErrorVerbiage: (state: HCPOnboardingState, action) => {
      state.errorVerbiage = action.payload
    },
    updateLoaderVerbiage: (state: HCPOnboardingState, action) => {
      state.loaderVerbiage = action.payload
    },
    updateSuccessVerbiageHTML: (state: HCPOnboardingState, action) => {
      state.successVerbiageHTML = action.payload
    },
    updateErrorVerbiageHTML: (state: HCPOnboardingState, action) => {
      state.errorVerbiageHTML = action.payload
    },
    updateLoaderVerbiageHTML: (state: HCPOnboardingState, action) => {
      state.loaderVerbiageHTML = action.payload
    },
    updateEnrollmentId: (state: HCPOnboardingState, action) => {
      state.enrollmentId = action.payload
    },
    updateSecureToken: (state: HCPOnboardingState, action) => {
      state.secureToken = action.payload
    },
    updatePortalDetails: (state: HCPOnboardingState, action) => {
      state.portalDetails = action.payload
    },
    updateMicrositeSelectedPersonaId: (state: HCPOnboardingState, action) => {
      state.microSiteselectedPersonaId = action.payload
    },
    updateMicrositeSelectedPersona: (state: HCPOnboardingState, action) => {
      state.microSiteselectedPersona = action.payload
    },
    updateEnrollmentFlowId: (state: HCPOnboardingState, action) => {
      state.enrollmentFlowId = action.payload
    },
    updateActiveLayoutId: (state: HCPOnboardingState, action) => {
      state.activeLayoutId = action.payload
    },
    updateActiveTemplate: (state: HCPOnboardingState, action) => {
      state.activeTemplate = action.payload
    },
    updateActiveSelectedServices: (state: HCPOnboardingState, action) => {
      state.selectedServices = action.payload
    },
    updateSelectedServicesData: (state: HCPOnboardingState, action) => {
      state.selectedServicesData = action.payload
    },
    updateEnrollmentLayoutSaveData: (state: HCPOnboardingState, action) => {
      state.enrollmentLayoutSaveData = action.payload
    },
    updateCopaySaveData: (state: HCPOnboardingState, action) => {
      state.copaySaveData = action.payload
    },
    updateCopayVerbiage: (state: HCPOnboardingState, action) => {
      state.copayVerbiage = action.payload
    },
    updateisCopayQuestionsEnabled: (state: HCPOnboardingState, action) => {
      state.isCopayQuestionsEnabled = action.payload
    },
    updateSiblingLayoutSaveData: (state: HCPOnboardingState, action) => {
      state.siblingLayoutSaveData = action.payload
    },
    updateMicrositePersonaDetails: (state: HCPOnboardingState, action) => {
      state.micrositePersonaDetails = action.payload
    },
    updateProviderInfoData: (state: HCPOnboardingState, action) => {
      state.providerInfo = action.payload
    },
    updateOnboardingClientData: (state: HCPOnboardingState, action) => {
      state.clientData = action.payload
    },
    updateOnboardingProgramClientInfoData: (
      state: HCPOnboardingState,
      action
    ) => {
      state.programAndClientInfoForHCP = action.payload
    },
    updateWorkingHoursByDateData: (state: HCPOnboardingState, action) => {
      state.workingHoursByDate = action.payload
    },
    updateLoginPageLoader: (state: HCPOnboardingState, action) => {
      state.showLoginPageLoader = action.payload
    },
    updateOnboardingHcpConfigurationData: (
      state: HCPOnboardingState,
      action
    ) => {
      state.hcpConfiguration = action.payload
    },
    updateCheckExistingFacility: (state: HCPOnboardingState, action) => {
      state.isDuplicateFacility = action.payload
    },
    updateCheckHCPUserEmailData: (state: HCPOnboardingState, action) => {
      state.checkHCPUserEmail = action.payload
    },
    updateShowOnboardingLoader: (state: HCPOnboardingState, action) => {
      state.showOnboardingLoader = action.payload
    },
    updateStatesData: (state: HCPOnboardingState, action) => {
      state.states = action.payload
    },
    updateSearchFacilityData: (state: HCPOnboardingState, action) => {
      state.searchFacilityData = action.payload
    },
    updateProviderAssociatedFacilitiesData: (
      state: HCPOnboardingState,
      action
    ) => {
      state.providerAssociatedFacilities = action.payload
    },
    updateApplicationInstructionsEnabled: (
      state: HCPOnboardingState,
      action
    ) => {
      state.isEnabledApplicationInstructions = action.payload
    },
    getNPIDataAction: () => {
      return
    },
    getWorkingHoursByDateDataAction: () => {
      return
    },
    getProgramClientInfoDataAction: () => {
      return
    },
    getOnboardingHcpConfigurationDataAction: () => {
      return
    },
    getClientDataAction: () => {
      return
    },
    postFinalOnboardingPayloadDataAction: () => {
      return
    },
    getCheckExistingFacilityDataAction: () => {
      return
    },
    getCheckHCPUserEmailDataAction: () => {
      return
    },
    getProviderInfoDataAction: () => {
      return
    },
    getStatesDataAction: () => {
      return
    },
    getProviderAssociatedFacilitiesAction: () => {
      return
    },
    getSearchFacilityDataAction: () => {
      return
    },
  },
})

export const {
  updateNPIData,
  getNPIDataAction,
  getProviderInfoDataAction,
  updateProviderInfoData,
  getStatesDataAction,
  updateStatesData,
  getSearchFacilityDataAction,
  updateSearchFacilityData,
  updateCheckHCPUserEmailData,
  getCheckHCPUserEmailDataAction,
  getProviderAssociatedFacilitiesAction,
  updateProviderAssociatedFacilitiesData,
  updateCheckExistingFacility,
  postFinalOnboardingPayloadDataAction,
  updateShowOnboardingLoader,
  getCheckExistingFacilityDataAction,
  getClientDataAction,
  updateOnboardingClientData,
  updateOnboardingProgramClientInfoData,
  getProgramClientInfoDataAction,
  updateOnboardingHcpConfigurationData,
  getOnboardingHcpConfigurationDataAction,
  getWorkingHoursByDateDataAction,
  updateWorkingHoursByDateData,
  updateLoginPageLoader,
  updatePortalDetails,
  updateMicrositePersonaDetails,
  updateMicrositeSelectedPersonaId,
  updateMicrositeSelectedPersona,
  updateEnrollmentFlowId,
  updateEnrollmentLayoutSaveData,
  updateCopaySaveData,
  updateCopayVerbiage,
  updateisCopayQuestionsEnabled,
  updateEnrollmentId,
  updateSuccessVerbiage,
  updateErrorVerbiage,
  updateLoaderVerbiage,
  updateSuccessVerbiageHTML,
  updateErrorVerbiageHTML,
  updateLoaderVerbiageHTML,
  updateFillPdfUrl,
  updateFillPdfEId,
  updateSelectedProductName,
  updateSelectedProductId,
  updateBackTrackingProductServicePage,
  updateBackMicrositeProductServicePage,
  updateConsenterName,
  updateConsenterPersona,
  updateMicrositeToken,
  updateMicrositeTokenCopy,
  updateLoggedInUserAuthInfo,
  updateHcpVerifyEmailId,
  updateHcpPracticeRegistrationSessionId,
  updateHCPPracticeId,
  updateHCPUserId,
  updateHCPUserTypeId,
  updateHCPPatientName,
  updateGlobalFont,
  updatePrimaryFont,
  updateHcpUserEmail,
  updateHcpDecodeToken,
  updateDocusignLoginCounter,
  updateHCPDocusignToken,
  updateDocusignValidationToken,
  updateHcpDefaultFacilitySearchData,
  updateApplicationInstructionsEnabled,
  updateIsTrackingPortal,
  updateSiblingLayoutSaveData,
  updateQuickDenialMsg,
  updateQuickDenialBackendMsg,
  updateHCPDefaultPatientInfoTrackingPortal,
  updateConsentEmail,
  updateMIDocs,
  updateMIConsent,
  updateApplicationStatusCaseId,
  updateSecureToken,
  updateButtonConfigurationPageSpecificFieldMap,
  updateActiveSelectedServices,
  updateSelectedServicesData,
  updateActiveTemplate,
  updateActiveLayoutId,
  updateExtendedMicrositePrefillData,
  updateMicrositePrefillData,
  updatePrefilledAttachmentData,
} = hcpOnboardingSlice.actions
export default hcpOnboardingSlice.reducer
